import { render, staticRenderFns } from "./view-failure-records.vue?vue&type=template&id=b835ca06&scoped=true"
import script from "./view-failure-records.vue?vue&type=script&lang=js"
export * from "./view-failure-records.vue?vue&type=script&lang=js"
import style0 from "./view-failure-records.vue?vue&type=style&index=0&id=b835ca06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b835ca06",
  null
  
)

export default component.exports